/* Package JSON Import will be here */
import React, { Fragment } from "react";
import { Button, Form, Modal, Segment, TextArea } from "semantic-ui-react";
import '@react-pdf-viewer/core/lib/styles/index.css';
import { Worker, Viewer } from '@react-pdf-viewer/core';
/* Package JSON Import will be here */

/* Project Import will be here */
import "../TMVoucherStyle.css";
import { Constants } from '../../../../config/appConstants'
import ConfirmationPopup from "../TMVoucherComponents/ConfirmationPopup";
import Loader from "../../../sharedComponent/loader/loader";
/* Project Import will be here */

const TMVoucherPDFViewer = (props) => {
    const ReportModal = () => {
        return (
            <Modal closeIcon open={props.tmVoucherPdf.isShowSubmitAndEmailModal} onClose={() => props.onClickSubmitAndEmailBtn(true)} closeOnDimmerClick={false}>
                <Modal.Header>{Constants.TM_VOUCHER_REPORT_MODAL_HEADER}</Modal.Header>
                <Modal.Content scrolling className="reportContent">
                    <Form>
                        <Form.Group className="d-flex flexDirectionColumn">
                            <Form.Field>
                                <Form.Dropdown required
                                    fluid search selection multiple allowAdditions
                                    label='To'
                                    name={Constants.TM_VOUCHER_SEND_TEXT}
                                    value={props.tmVoucherPdf.tmVoucherEmail.sendToEmailAddress}
                                    options={props.tmVoucherPdf.tmVoucherEmail.sendToEmailAddressList}
                                    placeholder='To'
                                    noResultsMessage={null}
                                    additionLabel={null}
                                    onChange={props.handleEmailChange}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group className="d-flex flexDirectionColumn">
                            <Form.Field className="w-100">
                                <Form.Dropdown
                                    fluid search selection multiple allowAdditions
                                    label='CC'
                                    name={Constants.TM_VOUCHER_CC_TEXT}
                                    value={props.tmVoucherPdf.tmVoucherEmail.ccEmailAddress}
                                    options={props.tmVoucherPdf.tmVoucherEmail.ccEmailAddressList}
                                    placeholder='CC'
                                    noResultsMessage={null}
                                    additionLabel={null}
                                    onChange={props.handleEmailChange}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group>
                            <Form.Field className="w-100">
                                <Form.Input className="inputBorderChanges"
                                    label="Subject"
                                    placeholder='Subject'
                                    name="subject"
                                    value={props.tmVoucherPdf.tmVoucherEmail.emailSubject}
                                    onChange={(e, { value }) => props.handleInputChange(value, Constants.TM_VOUCHER_SUBJECT_TEXT)} />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group>
                            <Form.Field className="w-100">
                                <label>Body</label>
                                <TextArea className="inputBorderChanges"
                                    placeholder='Body'
                                    name="body"
                                    rows={5}
                                    value={props.tmVoucherPdf.tmVoucherEmail.emailBody}
                                    onChange={(e, { value }) => props.handleInputChange(value, Constants.TM_VOUCHER_BODY_TEXT)} />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions className="tmVoucherReportBtn">
                    <Button secondary onClick={() => props.onClickSubmitAndEmailBtn(true)}>Cancel</Button>
                    <Button disabled={props.tmVoucherPdf.tmVoucherEmail.sendToEmailAddressList.length === 0 || props.tmVoucherPdf.isSendButtonDisabled} primary onClick={() => props.onClickSubmit(false, true)}>Send</Button>
                </Modal.Actions>
            </Modal>
        )
    }
    return (
        <Fragment>
            {!props.tmVoucherPdf.tmVoucherPdfBase64 ?
                <Loader />
                :
                <Fragment>
                    <Segment.Group>
                        <Segment className="overflowScroll pb-3" style={{ height: 'calc(100vh - 42px)', backgroundColor: '#fff' }}>
                            <div className="descriptionWidthTable mt-3">
                                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.2.228/build/pdf.worker.min.js">
                                    <Viewer fileUrl={Constants.PDFDATA_BASE64 + props.tmVoucherPdf.tmVoucherPdfBase64} />
                                </Worker>
                            </div>
                        </Segment>
                        <Segment>
                            <div className={`d-flex align-items ${(props.tmVoucherPdf.isFromDataEntry && !props.tmVoucherPdf.isProjectUnAssigned) ? 'justify-content-between' : 'justify-content-center'} btnFooter`}>
                                <Button secondary className="borderRadius w-10" size='small' onClick={props.onClickBackBtn}>{Constants.BUTTON_BACK}</Button>
                                {props.tmVoucherPdf.isFromDataEntry && !props.tmVoucherPdf.isProjectUnAssigned &&
                                    <div>
                                        <Button disabled={props.tmVoucherPdf.isSubmitButtonDisabled} type="button" secondary className="borderRadius" size='small' onClick={() => props.onClickSubmit(true)}>{Constants.TM_VOUCHER_SUBMIT}</Button>
                                        <Button disabled={props.tmVoucherPdf.isSubmitAndEmailButtonDisabled} type="button" secondary className="borderRadius" size='small' onClick={() => props.onClickSubmitAndEmailBtn()}>{Constants.TM_VOUCHER_SUBMIT_AND_EMAIL}</Button>
                                    </div>
                                }
                            </div>
                            {props.tmVoucherPdf.isShowLoader && <Loader />}
                        </Segment>
                        {props.tmVoucherPdf.isShowConfirmation &&
                            <ConfirmationPopup
                                isShowConfirmation={props.tmVoucherPdf.isShowConfirmation}
                                confirmationHeader={Constants.CONFIRMATION}
                                confirmationMessage={props.tmVoucherPdf.tmVoucherConfirmMessage}
                                yesText={Constants.YES_TEXT}
                                noText={Constants.NO_TEXT}
                                isShowYes={true}
                                isBtnDisabled={props.tmVoucherPdf.isSubmitButtonDisabled}
                                onClickCloseBtn={() => props.goOrCloseConfirmation()}
                                onClickYesBtn={() => props.goOrCloseConfirmation(true)}
                            />
                        }
                        {props.tmVoucherPdf.isShowSubmitAndEmailModal && ReportModal()}
                    </Segment.Group>
                </Fragment>
            }
        </Fragment>
    )
}


export default TMVoucherPDFViewer;

TMVoucherPDFViewer.displayName = "TMVoucherPDFViewer";